<template>
    <div class="col-sm-12" :class="{'disabled' : !page.isAdmin}" @click="onPageClick" >
        <div class="page">
            <div style="float: left;width: 50px">
                <img :src="'https://graph.facebook.com/'+ page.id +'/picture?width=100&height=100'" alt="">
            </div>
            <div class="detail" style="overflow-y: auto;float: left;padding: 0px 10px;max-width: 195px;">
                <!-- :style="{'margin-top' : page.isAdmin ? '15px' : '0px'}" -->
                <p style="margin:0;" >{{ page.name}}</p>
                <p class="sub-detail small" v-if="!page.isAdmin">No permission</p>
                <p class="sub-detail small" v-else>{{ role }}</p>
            </div>
            <!-- <div class="clearfix"></div> -->
        </div>
    </div>
</template>

<script>
    export default {
        props: ['value'],
        computed: {
            page: function(){
                let vm = this
                let page = this.value
                page.isAdmin = false
                if (page.perms) {
                    
                    $.each(page.perms,function(index, val){
                        if (val == "ADMINISTER") {
                            vm.role = 'Administer'
                            page.isAdmin = true
                            return false
                        }   
                    })
                }
                if (page.tasks) {
                    $.each(page.tasks,function(index, val){
                        if (val == "MANAGE") {
                            vm.role = 'Manage'
                            page.isAdmin = true
                            return false
                        }   
                    })
                }
                return page
            }
        },
        data: function(){
            return {
                role: ''
            }
        },
        methods: {
            onPageClick: function(){
                if (this.page.isAdmin) {
                    this.$emit('onPageClick',this.page)
                }
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/view/allbots/PageItem.vue